/* PAMĚŤ ODKAZŮ NA DOPORUČENÍ — samostatně a bez závislostí.
 *
 * Hotové odkazy (contactId → { odkaz, kdy }) a běžící požadavky drží
 * lib/doporuceni/odkazNaDoporuceni.js. Tady jsou zvlášť, aby je mohlo smazat
 * i odhlášení (contexts/AuthContext.js) bez načtení qrcode a lib/api:
 * lokální data klientů NESMÍ přežít odhlášení — na sdíleném počítači by
 * další přihlášený poradce dostal z paměti odkaz předchozího
 * (kontrola 14. 10. 2026). */
export const HOTOVE = new Map(); // contactId → { odkaz, kdy }
export const BEZI = new Map();   // contactId → Promise<string>

/** Zapomenout všechny odkazy (odhlášení, testy). */
export function zapomenOdkazyNaDoporuceni() {
  HOTOVE.clear();
  BEZI.clear();
}
